import type { CollectionId } from "@anaconda/core/nft-collection/types"
import { toCollectionId } from "@anaconda/core/nft-collection/utils"
import { createScope } from "bunshi"

export interface ScopeState {
  collectionId: CollectionId
}

export const CollectionScope = createScope<ScopeState>(
  {
    collectionId: toCollectionId("ETHEREUM:0x0"),
  },
  { debugLabel: "Collection Scope" },
)
